import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('network-groups', { routeName: 'networkResourceRoute' })
export class CoreNetworkGroup extends Resource {
  public id: string;
  public name: string;
  public shortName: string;
}
